__turbopack_context__.v({
  "className": "mona_sans_79bc222f-module__BOat8q__className",
  "variable": "mona_sans_79bc222f-module__BOat8q__variable",
});
